const BASE_URL =  'https://cassuss.com'

export default () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Cassuss E-commerce",
  "url": BASE_URL,
  "logo": `${BASE_URL}/logo.jpg`,
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+237694118310",
    "contactType": "customer service",
    "areaServed": "CM",
    "availableLanguage": ["fr"]
  }
})
